<template>
  <div class="commissionDatum">
    <!-- 标题：启用代理佣金设定 -->
    <div class="title">
      <!-- 复选框按钮and启用-->
      <label>
          <input type="checkbox" class="enable-btn" v-model="commission.enable" :disabled="version=='0'">&nbsp;
          <span class="enable-text">{{multiLanguage.enable}}</span>
      </label>
      <!-- 文本：代理佣金设定 -->
      <span class="table-title">{{multiLanguage.ibCommissionSetting}} <span v-if="version=='1'">({{ commission.isConfirm ? multiLanguage.confirmed : multiLanguage.unconfirmed }})</span></span>
      <div v-if="templateLang" class="template-box">
        <span>{{multiLanguage.templateName}}: </span> <span class="enable-text">{{templateLang}}</span>
      </div>
      <!-- 按钮组 -->
      <div class="btn-box pull-right">
        <!-- 确认审核 -->
        <button class="btn" v-if="version == '1'" @click="verify">
          <span class="glyphicon glyphicon-ok"></span>
          {{multiLanguage.btnGroup.check}}
        </button>
        <!-- 保存修改 -->
        <button class="btn" v-if="version == '1'" @click="submit">
          <span class="glyphicon glyphicon-edit"></span>
          {{multiLanguage.btnGroup.submit}}
        </button>
        <!-- 返回之前数据 -->
        <button class="btn" v-if="version == '1'" @click="pageInit('0')">
          <span class="glyphicon glyphicon-repeat"></span>
          {{multiLanguage.btnGroup.backData}}
        </button>
      </div>
      <div class="pull-right" style="margin:5px">
          <input type="checkbox" v-model="commission.isSpecial">
          <span style="color: #F08712;font-weight: 700;font-size: 14px;">{{multiLanguage.specialCommission}}</span>
      </div>
      <div class="clear"></div>
    </div>
    <div>
      <!-- 最后修改 or 审核的人 and 时间 -->
      <div class="last-update-box">
        <span class="pull-left">{{multiLanguage.updateBy}} : {{commission.updateBy}} <span v-if="commission.lastUpdate">({{commission.lastUpdate}})</span></span>
        <span class="pull-left" style="margin-left:20px" v-if="true">{{multiLanguage.confirmBy}} : {{commission.confirmBy}} <span v-if="commission.lastConfirm">({{commission.lastConfirm}})</span></span>
        <div class="clear"></div>
      </div>
      <!-- cpa 和 内返的的预设标准 -->
      <div class="cpa-switch-box">
        <div class="cpa-switch pull-left">
          <btn class="internal" :class="{'active': mode == 0 && commission.enable}" :disabled="!commission.enable || version == '0'" @click="mode = 0">
            {{multiLanguage.commonCaculation}}
          </btn>
          <btn class="CPA" :class="{'active': mode == 1 && commission.enable}" :disabled="!commission.enable || version == '0'" @click="mode = 1" v-if="commission.cpa !== 'not exist'">
            {{multiLanguage.CPACaculation}}
          </btn>
          <btn class="internalAndCPA" :class="{'active': mode == 2 && commission.enable}" :disabled="!commission.enable || version == '0'" @click="mode = 2" v-if="commission.cpa !== 'not exist'">
            {{multiLanguage.comAndCPA}}
          </btn>
        </div>
        <div class="preinstall-box pull-right" :style="version == '0' ? 'visibility:hidden;' : ''">
          <Dropdown menu-right>
            <button data-role="trigger" class="btn btn-default dropdown-toggle" type="button" :disabled="!commission.enable || version == '0'">
                <span>{{multiLanguage.SettingTemplate}}</span>
                <span class="caret"></span>
            </button>
            <template slot="dropdown">
              <li v-for="(item,index) in ibTemplate" v-if="item.isDisplay" @click="normSetFn(item.templateId,'ib')">
                <a>{{multiLanguage[item.langKey]|| item.templateId}}</a>
              </li>
            </template>
          </Dropdown>
          <Dropdown menu-right v-if="commission.cpa !== 'not exist'">
            <button data-role="trigger" class="btn btn-default dropdown-toggle" type="button" :disabled="!commission.enable || version == '0'">
                <span>{{multiLanguage.cpa_SettingTemplate}}</span>
                <span class="caret"></span>
            </button>
            <template slot="dropdown">
                <li v-for="(item,index) in cpaTemplate" v-if="item.isDisplay" @click="normSetFn(item.templateId,'cpa')">
                    <a role="button">{{multiLanguage[item.langKey]}}</a>
                </li>
            </template>
          </Dropdown>
        </div>
        <div class="clear"></div>
      </div>
      <!-- 子组件：内返佣金设定 -->
      <internal-commission v-if="mode == 0 || mode == 2"
        :commission="commission"
        :groupSeq="groupSeq"
        :multiLanguage="multiLanguage"
        :version="version"
        :viewBtn="viewBtn"
        ref="internalCommission">
      </internal-commission>
      <!-- 子组件：cpa设定 -->
      <cpa-commission v-if="mode == 1 || mode == 2"
        :commission="commission"
        :multiLanguage="multiLanguage"
        :version="version"
        :viewBtn="viewBtn"
        :style="mode == '2' ? 'margin-top:10px' : ''"
        ref="cpaCommission">
      </cpa-commission>
      <!-- 到期时间 和 到期提示信息 -->
      <div class="expired-box">
        <div  class="pull-left ReminderDate">
          <h4>{{multiLanguage.reminderDate}}</h4>
          <el-date-picker
              v-model="commission.ReminderDate"
              type="datetime"
              :disabled="!commission.enable || version == '0'"
              :placeholder="multiLanguage.choiceDateTime"
              @change="timeIsChange = true">
          </el-date-picker>
        </div>
        <div class="pull-right ReminderMsg">
          <h4 class="pull-left">{{multiLanguage.reminderMsg}}</h4>
          <span class="pull-left text-success send-eml" v-show="commission.sendEml">{{multiLanguage.sented}}</span>
          <div class="clear"></div>
          <el-input
              type="textarea"
              :rows="4"
              :disabled="!commission.enable || version == '0'"
              :placeholder="multiLanguage.reminderMsgPlaceholder"
              v-model="commission.ReminderMsg"
              @change="timeIsChange = true">
          </el-input>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- 标题：启用多层佣金分配 -->
    <div class="title">
      <label>
        <input type="checkbox" class="enable-btn" v-model="commission.enableUpperCalc" :disabled="version=='0'">&nbsp;
        <span class="enable-text">{{multiLanguage.enable}}</span>
      </label>
      <span class="table-title">{{multiLanguage.upperCommissiondistribution}}</span>
    </div>
    <div>
      <!-- 子组件：规则设定 -->
      <rule-setting
        :enableUpperCalc="commission.enableUpperCalc"
        :multiLanguage="multiLanguage"
        :groupSeq="groupSeq"
        :version="version"
        :relation="relation"
        :currentIB="currentIB"
        :rule="rule"
        :ruleSeq="ruleSeq"
        :viewBtn="viewBtn"
        ref="ruleSetting"
        @checkId="checkIdFn">
      </rule-setting>
    </div>
    <!-- 第三方组件：模态框，弹出成功 or 失败的提示信息 -->
    <Modal v-model="showModal" size="sm" :header="false" :footer="false">
      <div v-show="!sucSave">
          <i class="glyphicon glyphicon-warning-sign color-red"></i>
          <span class="color-red">{{multiLanguage.submitResult.err}}</span>
      </div>
      <div v-show="sucSave">
          <i class="glyphicon glyphicon-ok color-green"></i>
          <span class="color-green">{{multiLanguage.submitResult.succeed}}</span>
      </div>
    </Modal>
  </div>
</template>

<script>
  var moment = require('moment');
  moment().format();
  import internalCommission from './internalCommission'
  import cpaCommission from './cpaCommission'
  import ruleSetting from './ruleSetting'
  import { URL_IBSET,URL_DEFAULT,URL_TOOLCHECKID } from 'api/commissionApi'
  import { getTimeDiff,updateTimeByUtc } from 'common/js/util'
  import { Modal,Btn,Dropdown } from 'uiv'
  import { Api } from 'api/commissionEnv'
  var api = new Api()
  export default {
    mixins: [ require("common/mixin/base.js").base({multiLanguageTable:"commissionTable"}), ],
    props: {
      curArea: {
        type: String,
        default: ''
      },
      multiLanguage: { //多语言
        type: Object,
        default: {}
      },
      version: { // 版本
        type: String,
        default: ''
      },
      viewBtn: { // 视图
        type: String,
        default: ''
      }
    },
    components:{
      Modal,
      Btn,
      Dropdown,
      internalCommission,
      cpaCommission,
      ruleSetting
    },
    data () {
      return {
        showModal: false,
        sucSave: false,
        UTCDIFF: getTimeDiff(),
        mode: 0,
        timeIsChange: '',
        enableDistribution: api.enableDistribution,
        commission: {
          cpa: [],
          enable: false,
          lvl: [],
          ReminderDate: '',
          ReminderMsg: '',
          sendEml: '',
          enableUpperCalc: '',
          updateBy: '',
          lastUpdate: '',
          confirmBy: '',
          lastConfirm: '',
          isConfirm: false,
          isSpecial: false,
          templateId: null,
          templateOverwrite:false,
        },
        groupSeq: [],
        relation: [],
        rule: [],
        ruleSeq: [],
        currentIB:{},
        ibTemplate: null,
        cpaTemplate: null
      }
    },
    mounted () {
      this.pageInit(this.version)
    },
    computed: {
      lvlLawful1 () { // 检查lvl的开始和结束是否合法
        let res = true
        if (this.mode == '0' || this.mode == '2') {
          this.commission.lvl.forEach((item,index) => {
            if(index < this.commission.lvl.length-1) {
              res = item.start - item.end > 0 ? false : true
            }
          })
        }
        return res
      },
      lvlLawful2 () { // 检查lvl的区间是否连贯
        let res = true
        if (this.mode == '0' || this.mode == '2') {
          this.commission.lvl.forEach((item,index) => {
            if(this.commission.lvl[index+1]) {
              if (!((this.commission.lvl[index+1].start - this.commission.lvl[index].end).toFixed(2) == 0.01)) {
                res = false
                return
              }
            }
          })
        }
        return res
      },
      cpaLawful1 () { // 检查cpa的开始和结束是否合法
        let res = true
        if (this.mode == '1' || this.mode == '2') {
          this.commission.cpa.forEach((item,index) => {
            if(index < this.commission.cpa.length-1) {
              res = item.start - item.end > 0 ? false : true
            }
          })
        }
        return res
      },
      cpaLawful2 () { // 检查cpa的区间是否连贯
        let res = true
        if (this.mode == '1' || this.mode == '2') {
          this.commission.cpa.forEach((item,index) => {
            if(this.commission.cpa[index+1]) {
              if (!((this.commission.cpa[index+1].start - this.commission.cpa[index].end).toFixed(2) == 1)) {
                res = false
                return
              }
            }
          })
        }
        return res
      },
      updateData () { // 需要更新的数据
        this.commission.lvl.forEach((item,index) => {
          item.lvl = index+1
          if(index == this.commission.lvl.length-1) item.end = '-1.00'
          if(index == 0) item.start = '0.00'
        })
        if (this.commission.cpa !== 'not exist') {
          this.commission.cpa.forEach((item,index) => {
            if(index == this.commission.cpa.length-1) item.end = '-1.00'
            if(index == 0) item.start = '1.00'
          })
        }
        return {
          commission: {
              ibId: this.$route.query.id,
              updateBy: JSON.parse(sessionStorage.user).user_name,
              enable: this.commission.enable,
              isSpecial: this.commission.isSpecial,
              expiredDate: this.commission.ReminderDate,
              expiredMessage: this.commission.ReminderMsg,
              expiredMessageSend: this.timeIsChange ? false : this.commission.sendEml,
              lvl: this.commission.lvl,
              cpa: this.commission.cpa,
              mode: this.mode,
              enableUpperCalc: this.enableDistribution ? this.commission.enableUpperCalc : false,
              templateId: this.commission.templateId || false,
              //templateOverwritten: this.commission.templateOverwrite?1:0,
          },
          rule: this.rule
        }
      },
      verifyData () { // 提交审核的参数
        return {
          commission: {
            ibId : this.$route.query.id,
            confirmBy: JSON.parse(sessionStorage.user).user_name
          }
        }
      },
      templateLang () {
        if(!this.ibTemplate || this.ibTemplate.length == 0) return '';
        let temp = this.ibTemplate.find(it=>it.templateId == this.commission.templateId)
        if(!temp) return '';
        let lang = this.multiLanguage[temp.langKey]|| temp.templateId
        let i = this.commission.templateOverwrite?1:0
        return `${lang}(${this.multiLanguageTable.ibTempOverwriteType[i]})`
      }
    },
    methods: {
      pageInit (version) {// 初始化数据
        let oId = this.$route.query.id
        this.$http.get(api.getUrl20(this.curArea,URL_IBSET)+'/'+version+'/'+oId,{headers:{UTCDIFF: this.UTCDIFF}}).then(res => {
          if (res.data.code == 200 && res.data.data && res.data.msg == 'OK'){
            let data = res.data.data
            this.mode = data.commission.mode
            this.commission.enable = data.commission.enable
            this.commission.lvl = data.commission.lvl
            this.commission.cpa = data.commission.cpa
            this.commission.ReminderDate = data.commission.expiredDate
            this.commission.ReminderMsg = data.commission.expiredMessage
            this.commission.sendEml = data.commission.expiredMessageSend
            this.commission.enableUpperCalc = data.commission.enableUpperCalc
            this.commission.updateBy = data.commission.updateBy
            this.commission.lastUpdate = data.commission.lastUpdate ? updateTimeByUtc(this.UTCDIFF,data.commission.lastUpdate) : data.commission.lastUpdate
            this.commission.confirmBy = data.commission.confirmBy
            this.commission.lastConfirm = data.commission.lastConfirm ? updateTimeByUtc(this.UTCDIFF,data.commission.lastConfirm) : data.commission.lastConfirm
            this.commission.isConfirm = data.commission.isConfirm
            this.commission.isSpecial = data.commission.isSpecial
            this.commission.templateId = data.commission.templateId
            this.commission.templateOverwrite = data.commission.templateOverwritten
            this.groupSeq = data.groupSeq
            this.relation = data.relation.slice(0,-1)
            this.currentIB = {
              id: data.commission.ibId,
              ibc: data.relation[data.relation.length-1].ibc || null,
              name: data.commission.name
            }

            this.rule = data.rule.length > 0 ? data.rule : [[]]
            this.ruleSeq = data.ruleSeq
            this.ibTemplate = data.template.ibTemplate
            this.cpaTemplate = data.template.cpaTemplate
          }
        })
      },
      submit () {// 提交
        function isTrueFn(element) {
          return (element == true)
        }
        let arr = []
        if (this.mode == '0' || this.mode == '2') arr.push(this.$refs.internalCommission.$validator.validateAll())
        if (this.mode == '1' || this.mode == '2') arr.push(this.$refs.cpaCommission.$validator.validateAll())
        arr.push(this.$refs.ruleSetting.$validator.validateAll())
        Promise.all(arr).then(result => {
          if(this.lvlLawful1 && this.lvlLawful2 && this.cpaLawful1 && this.cpaLawful2 && result.every(isTrueFn) && this.checkRuleSetting1(this.updateData.rule)) {
            // 发请求去保存
            // console.log('发请求')
            this.$http.post(api.getUrl20(this.curArea,URL_IBSET)+'/1',this.updateData).then(res => {
              if (res.data.code == 200 && res.data.data.msg == "OK")  {
                //this.showModal = true
                //this.sucSave = true
                this.$message.success(this.multiLanguage.submitResult.succeed)
                this.commission.updateBy = JSON.parse(sessionStorage.user).user_name
                this.commission.lastUpdate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                this.commission.isConfirm = false
                this.commission.templateOverwrite = res.data.data.templateOverwritten
              }
              else {
                //this.showModal = true
                //this.sucSave = false
                this.$message.error(this.multiLanguage.submitResult.serverErr)
              }
            })
          } else {
            this.showModal = true
            this.sucSave = false
          }
        })
      },
      verify () {// 确认审核
        if (!this.commission.updateBy)
        {
          alert(this.multiLanguage.alertMsg.beforeSave)
          return
        }
        else if (this.verifyData.commission.confirmBy == this.commission.updateBy){
          alert(this.multiLanguage.alertMsg.checkFail)
          return
        }else {
          let msg = this.multiLanguage.alertMsg.verifyTips
          if (confirm(msg) == true) {
            this.$http.post(api.getUrl20(this.curArea,URL_IBSET)+'/0',this.verifyData).then(res => {
              if (res.data.code == 200 && res.data.data.msg == "OK") {
                //this.showModal = true
                //this.sucSave = true
                this.$message.success(this.multiLanguage.submitResult.auditSuccess)
                this.commission.isConfirm = true
                this.$emit('afterVerify')
              }
              else {
                //this.showModal = true
                //this.sucSave = false
                this.$message.error(this.multiLanguage.submitResult.serverErr)
              }
            })
          }
        }
      },
      normSetFn (path,type) {// 拿到内设数据
        this.$http.get(api.getUrl20(this.curArea,URL_DEFAULT)+path).then((res) => {
          if (res.data.code === 200) {
            if (type === 'ib'){
              this.commission.lvl = res.data.data.setting
              this.mode = (this.mode !== 2) ? 0 : 2
              this.commission.enableUpperCalc = true
              this.rule = res.data.data.rulemapping
              this.rule.forEach(val => {
                val.forEach(v => {
                  v.value = +v.value ? parseFloat(v.value).toFixed(4) : 0;
                });
              });
              this.commission.templateId = path
              this.commission.templateOverwrite = false
            }
            else if (type === 'cpa') {
              this.commission.cpa = res.data.data.setting
              this.mode = (this.mode !== 2) ? 1 : 2
              this.commission.enableUpperCalc = true
              this.rule = res.data.data.rulemapping
            }
          }
        })
      },
      checkIdFn (ruleItem) { // 检查id是否在关系图
        this.$http(api.getUrl20(this.curArea,URL_TOOLCHECKID),{params:{id: ruleItem.commTarget,type: 'IB'}}).then(res => {
          let result = res.data.data.result
          if (!result) {
            alert(this.multiLanguage.alertMsg.noAccount)
            ruleItem.commTarget = ''
          }
        })
      },
      checkRuleSetting1(rule) {
        let checkRule = {}
        for (let val of rule) {
            let rCheck = {}
            for (let r of val) {
                if (r.ruleId == 3 || r.ruleId == 5) {
                    if (!checkRule[`${r.ruleId}-${r.ruleGroup}`]) {
                        checkRule[`${r.ruleId}-${r.ruleGroup}`] = { count: 1, content: JSON.stringify({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) }
                    } else {
                        if (JSON.stringify({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) != checkRule[`${r.ruleId}-${r.ruleGroup}`].content) {
                          // 存在“分层最高金额”这个规则设定时，加点、外佣、内返的值必须相同
                          alert(this.multiLanguage.alertMsg.checkRuleFail1)
                          return false
                        }
                        else {
                            checkRule[`${r.ruleId}-${r.ruleGroup}`].count++
                        }
                    }
                    if (rCheck[`${r.ruleId}-${r.ruleGroup}`] == undefined) rCheck[`${r.ruleId}-${r.ruleGroup}`] = true
                    else {
                      return false
                    }
                }
            }
        }
        for (let key in checkRule) {
            if (checkRule[key].count != rule.length) {
              // 存在“分层最高金额”这个规则时，每个级别都必须有一条相同的“分层最高金额”，并保证“加点、外佣、内返”一致
              alert(this.multiLanguage.alertMsg.checkRuleFail2)
              return false
            }
        }
        return true
      }
    },
  }
</script>

<style lang="scss" scoped>
  .commissionDatum{
    input[type='checkbox']{
      vertical-align: middle;
      margin-top: 0;
    }
    .title{
      position: relative;
      border-bottom: 2px solid #3F51B5;
      input[type='checkbox']{
        width: 22px;
        height: 22px;
      }
      span{
        color: #3F51B5;
        font-weight: 550;
        font-size: 15px;
      }
      .enable-btn{
        width: 15px;
        height: 15px;
      }
      .enable-text{
        font-size: 16px;
        font-weight: 700;
        color: #F08712;
      }
      .table-title{
        font-size: 20px;
        margin-left: 20px;
      }
      .btn-box{
        height: 50px;
        button{
          margin-left: 10px;
          background-color: #3f51b5;
          color:#fff;
        }
        span{
          color: #fff;
        }
      }
    }
    .last-update-box{
      margin-top: 5px;
      text-align: right;
      color: #3f51b5;
      font-weight: 550;
      font-size: 16px;
    }
    .cpa-switch-box{
      margin: 5px 0 10px;
      .cpa-switch{
        .internal{
          border-radius: 3px 0 0 3px;
        }
        .CPA{
          border-radius: 0;
          margin-left: -4px;
        }
        .internalAndCPA{
          border-radius: 0 3px 3px 0;
          margin-left: -5px
        }
        .active{
          background-color: #3F51B5!important;
          color: #fff!important;
        }
        .default-color{
          color: #333;
        }
      }
    }
    .expired-box{
        margin: 10px 0;
        .ReminderDate,.ReminderMsg{
            width: 49%;
        }
        .send-eml{
            margin-left: 20px;
            margin-top: 16px;
        }
    }
    .disabled{
      background: #e9e9e9;
      border-color: #e9e9e9;
      color: #333;
    }
    .template-box{
      display:inline-block;
      margin-left:20px;
      max-width:400px;
      height: 20px;
      overflow:hidden;
      text-overflow: ellipsis;
      word-break:keep-all;
      white-space:nowrap;
      z-index: -100000;
    }
  }
</style>



// WEBPACK FOOTER //
// ibCommissionSettingContent.vue?3abe7152